import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ChangePersonalAddressProps {
  businessFlow: boolean;
}
export const ChangePersonalAddressHeader = ({ businessFlow }: ChangePersonalAddressProps) => {
  const { t } = useTranslation();
  const title = t('CHANGE_ADDRESS.TITLE', { type: businessFlow ? 'business' : 'personal' });

  return (
    <div className='flex flex-col justify-center items-center pb-[24px]'>
      <p className='text-bw08 text-[24px] h-[32px] font-metricR w-full text-center mb-[5px]' id='header'>
        {title}
      </p>
    </div>
  );
};

export default ChangePersonalAddressHeader;
